import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UserDataService {
  private userData: any = null;
  public details = new BehaviorSubject<any>(this.userData);
  $userData = this.details.asObservable();
  public showConfimationBox = new BehaviorSubject<any>(false);

  private customerDataSubject = new BehaviorSubject<any>(null);
  $customerData = this.customerDataSubject.asObservable();

  get customerSnapshot(): any {
    return this.customerDataSubject.value;
  }

  updateCustomerData(customer: any) {
    this.customerDataSubject.next(customer);
  }

  private policyNumber: any = "";
  public policyNumberSub = new BehaviorSubject<any>(this.userData);
  $policyNumber = this.policyNumberSub.asObservable();


  updatePolicyNumber(policyNumber) {
    this.policyNumberSub.next(policyNumber);
  }

  updateUserDetails(userData: any) {
    this.details.next(userData);
  }

  clear() {
    this.details.next('');
  }

  updateConfimationValue(status: any) {
    this.showConfimationBox.next(status);
  }

  getConfimationValue() {
    return this.showConfimationBox.asObservable();
  }
}
